<template>
  <span :class="['tag', isActive ? 'active' : '']">{{ content }}</span>
</template>

<script>
export default {
  name: "Tag",
  props: {
    content: {
      type: String,
    },
    isActive: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

<style lang="less" scoped>
.tag {
  position: relative;
  display: inline-block;
  background: #ffffff;
  border-radius: 8/200rem;
  padding: 0 8/200rem;
  font-size: 20/200rem;
  font-family: PingFangSC-Regular, PingFang SC;
  color: @color-theme;
  line-height: 32/200rem;
  // box-shadow: 0px 0px 0px 0.5px @color-theme;
  &:not(:first-child) {
    margin-left: 12/200rem;
  }
  &.active {
    background: #fff5eb;
  }
  &::before {
    content: "";
    position: absolute;
    top: -50%;
    bottom: -50%;
    left: -50%;
    right: -50%;
    width: 200%;
    height: 200%;
    -webkit-transform: scale(0.5);
    transform: scale(0.5);
    border: solid 1px @color-theme;
    border-radius: 8px;
    box-sizing: border-box;
  }
}

</style>
